export default "__VITE_ASSET__5lg16w5k__"